import idb from "../idb.js";

export default {
  async insertFinnSites(finnSites) {
    let db = await idb.getDb();

    return new Promise((resolve) => {
      let trans = db.transaction(["finnSites"], "readwrite");
      let store = trans.objectStore("finnSites");

      finnSites.forEach((finnSite) => {
        store.put(finnSite);
      });
    });
  },

  async clearAll() {
    let db = await idb.getDb();

    return new Promise((resolve) => {
      let trans = db.transaction(["finnSites"], "readwrite");
      let store = trans.objectStore("finnSites");
      store.clear();
    });
  },

  async getFinnSites() {
    let db = await idb.getDb();

    return new Promise((resolve) => {
      let trans = db.transaction(["finnSites"], "readonly");
      trans.oncomplete = () => {
        resolve(finnSites);
      };

      let store = trans.objectStore("finnSites");
      let finnSites = [];

      store.openCursor().onsuccess = (e) => {
        let cursor = e.target.result;
        if (cursor) {
          finnSites.push(cursor.value);
          cursor.continue();
        }
      };
    });
  },
};
